const TOKEN_KEY = `token_${process.env.REACT_APP_ID}`;
const REFRESH_TOKEN_KEY = `refresh_${process.env.REACT_APP_ID}`;
const EXPIRATION_KEY = `expires_${process.env.REACT_APP_ID}`;
const VERSION = 'APP_VERSION';
const STATIC_CONTENT = `static-content_${process.env.REACT_APP_ID}`;
const STATIC_CONTENT_REQUESTED = `static-content-requested_${process.env.REACT_APP_ID}`;
const OPERATION_UUID = `operation-uuid_${process.env.REACT_APP_ID}`;
const CONTEXT = `context-uuid-${process.env.REACT_APP_ID}`;

const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);
const getRefresh = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY);
const getExpirationDate = (): string | null => localStorage.getItem(EXPIRATION_KEY);
const getStaticContent = (): string | null => localStorage.getItem(STATIC_CONTENT);
const getStaticContentRequested = (): string | null => localStorage.getItem(STATIC_CONTENT_REQUESTED);
const getAppVersion = (): string | null => localStorage.getItem(VERSION);
const getOperationUuid = (): string | null => localStorage.getItem(OPERATION_UUID);
const getContext = (): any | null => localStorage.getItem(CONTEXT);
const setContext = (context: any): void => localStorage.setItem(CONTEXT, context);

const setOperationUuid = (uuid: string): void => localStorage.setItem(OPERATION_UUID, uuid);
const setToken = (token: string): void => localStorage.setItem(TOKEN_KEY, token);
const setRefreshToken = (token: string): void => localStorage.setItem(REFRESH_TOKEN_KEY, token);
const setExpirationDate = (timestamp: string): void => localStorage.setItem(EXPIRATION_KEY, timestamp);
const setStaticContent = (content: string): void => localStorage.setItem(STATIC_CONTENT, content);
const setStaticContentRequested = (timestamp: string): void =>
  localStorage.setItem(STATIC_CONTENT_REQUESTED, timestamp);

export {
  getToken,
  getRefresh,
  getExpirationDate,
  getStaticContent,
  getStaticContentRequested,
  getAppVersion,
  setToken,
  setRefreshToken,
  setExpirationDate,
  setStaticContent,
  setStaticContentRequested,
  getOperationUuid,
  setOperationUuid,
  getContext,
  setContext,
};
